module.exports = __webpack_public_path__ + "media/images/championship__iconCorrect-ca2e762ed248e33943e366c8b2839c34.png";